import { toast } from "react-toastify";

export const handleCopy = (text: string, notificationText?: string) =>
  toast.promise(navigator.clipboard.writeText(text), {
    pending: "Copying...",
    success: notificationText ?? "Copied to clipboard",
    error: "Cannot copy to clipboard"
  });

// Safari only allows clipboard writes while the click's transient user
// activation is alive, so when the text comes from a network request the
// write must start synchronously with the pending promise instead of after
// awaiting it. Call this synchronously inside the click handler.
export const writeClipboardTextFromPromise = async (
  textPromise: Promise<string>
) => {
  if (typeof ClipboardItem !== "undefined" && navigator.clipboard.write) {
    await navigator.clipboard.write([
      new ClipboardItem({
        "text/plain": textPromise.then(
          (text) => new Blob([text], { type: "text/plain" })
        )
      })
    ]);
    return;
  }
  await navigator.clipboard.writeText(await textPromise);
};
